import React, { useEffect } from 'react'
import PlusIcon from '../../../../components/elements/icons/PlusIcon'
import { Link } from 'react-router-dom'
import DocumentSvgIcon from '../../../../assets/images/icons/document-icon.svg'
import { useDispatch, useSelector } from 'react-redux'
import { fetchDocuments } from '../../../../store/actions/documentActions'
import Preloader from '../../../../components/elements/Preloader'
import AdministrationLayout from '../../../../components/layouts/AdministrationLayout'
import EmptyState from '../../../../components/elements/EmptyState'

const Documents = () => {
  const dispatch = useDispatch()
  const documentsSelector = useSelector(state => state.documents)

  useEffect(() => {
    dispatch(fetchDocuments())
    return () => {
      
    };
  }, [dispatch]);
  return (
    <>
      <AdministrationLayout pageTitle={`Documents`}>
        {documentsSelector.loadingDocuments ? 
          <Preloader />
          :
          <div className=''>
            <div className='w-full lg:flex flex-row gap-x-8'>
              <div className='w-full pb-6 mx-auto'>
                <div className='flex justify-between items-center mb-4'>
                  {/* <h3 className='font-medium text-lg text-gray-400'>Documents </h3> */}
                  <div className='w-9/12'>
                    <h3 className='text-lg font-medium'>Vaatia College Documents</h3>
                    <p className='text-sm'>These documents serve as templates that can be sent or assigned to users, students, parents or applicants at various times. You can create a new document by clicking "Create document".</p>
                  </div>

                  <Link to={`new-document`}>
                    <button className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                      <PlusIcon className='w-5 h-5' /> Create Document
                    </button>
                  </Link>
                </div>

                {documentsSelector.documents?.documents?.length > 0 ? <div className='grid grid-cols-3 gap-6'>
                  {documentsSelector.documents?.documents?.map((document, documentIndex)=>(<Link key={documentIndex} to={`details/${document._id}`}>
                    <div className='w-full p-5 flex items-start gap-x-3 border bg-white border-transparent hover:border-gray-200 transition duration-200 cursor-pointer'>
                      <div className='w-[100px] h-inherit pt-1'>
                        <img src={DocumentSvgIcon} alt="" />
                      </div>
                      <div className='w-full'>
                        <p className='text-sm font-medium text-vcm-purple'>{document.name}</p>
                        <p className='text-xs text-gray-500'>{document.description}</p>
                        <p className='text-xs text-gray-500 mt-3'>Created {new Date(document.createdAt)?.toLocaleDateString()}</p>
                      </div>
                    </div>
                  </Link>))}
                </div>
                :
                <div className='mt-12 w-1/3 mx-auto'>
                  <EmptyState emptyStateText={`No documents created yet. You can create a new document by clicking on the "Create Document" button above`} />
                </div>
                }

              </div>
            </div>
          </div>
        }
      </AdministrationLayout>
    </>
  )
}

export default Documents